// extracted by mini-css-extract-plugin
export var carrierIcon = "_xv-0";
export var carrierLogo = "_xv-1";
export var detailsSection = "_xv-2";